export class MoleculePanelOverviewHeaderMultiDeleteEmailActionComponent {
    public templateUrl = require('./multi-delete-email-action.html?external');
}
